/* eslint-disable no-unused-vars */
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useMedication = create((set, get) => ({
  searchMedication: null,
  medicationData: [],
  loading: null,
  error: null,
  get: async (search) => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query
      const { status, data, error, isFetching } = await queryClient.fetchQuery([
        search?.length > 0
          ? `/getMasterDrugs/getAll?limit=10&search=${search}`
          : '/getMasterDrugs/getAll?limit=10',
        'get',
      ]);
      const medicationDataDummy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          medicationDataDummy.push({
            value: val?.id ?? '',
            label: val?.drug_name ?? '',
            labelShow: val?.drug_name ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        medicationData: medicationDataDummy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.response?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
